const tagName = 'global-menu-generic-icon';
const template = require('../templates/global-menu-generic-icon.ejs');

export default class GlobalMenuGenericIcon extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
    this.classList.add(tagName);
    this.name = this.dataset.name.trim();
    this.length = this.dataset.length || 1;

    this.innerHTML = template({
      letters: this.letters(),
      fillcolor: this.fillcolor()
    });

  }

  letters() {
    return (this.name || '').toUpperCase()
      .split(/[ ]+/).reduce((acc, curr) => acc + curr.charAt(0), '')
      .substr(0, this.length);
  }

  fillcolor() {
    let color;
    try {
      color = colors[this.name.charAt(0).toUpperCase()];
    } catch (err) {
      color = '#D0D4D8';
    }
    return color;
  }

}

const colors = {
  '0': '#A969A8',
  '1': '#7AFD5C',
  '2': '#39F82F',
  '3': '#D0C25E',
  '4': '#D9F19B',
  '5': '#F97B9A',
  '6': '#998454',
  '7': '#3C78E6',
  '8': '#914DB1',
  '9': '#D87029',

  'A': '#9CCC65',
  'B': '#29B6F6',
  'C': '#FF9800',
  'D': '#AB47BC',
  'E': '#26C6DA',
  'F': '#8D6E63',
  'G': '#9E9E9E',
  'H': '#7E57C2',
  'I': '#FFAB91',
  'J': '#66BB6A',
  'K': '#5C6BC0',
  'L': '#26A69A',
  'M': '#42A5F5',
  'N': '#CDDC39',
  'O': '#FF7043',
  'P': '#EC407A',
  'Q': '#BCAAA4',
  'R': '#F44336',
  'S': '#90A4AE',
  'T': '#009688',
  'U': '#F48FB1',
  'V': '#512DA8',
  'W': '#81D4FA',
  'X': '#333333',
  'Y': '#FDD835',
  'Z': '#388E3C'
};

if (!customElements.get(tagName)) {
  customElements.define(tagName, GlobalMenuGenericIcon);
}



// WEBPACK FOOTER //
// ./src/scripts/global-menu-generic-icon.js